import React from "react";
import "./CalendarSidebar.css";
import { useApp } from "../../../AppProvider";
import Avatar from '@mui/material/Avatar';
import { Link } from "react-router-dom";

function CalendarSidebar() {
  const { boardData, setSelectedPatient, stringAvatar, stringToColor } = useApp();

  const handleSelectPatient = (patient) => {
    setSelectedPatient(patient.patientId);
  }

  function getEventColor(eventType) {
    switch (eventType) {
      case "New":
        return "new-bg";
      case "Follow-up Consultation":
        return "regular-bg";
      case "Critical":
        return "critical-bg";
      case "Normal Consultation":
        return "published-bg-non";
      default:
        return "";
    }
  }

  function getTextColor(eventType) {
    switch (eventType) {
      case "New":
        return "new-calendar";
      case "Follow-up Consultation":
        return "regular-calendar";
      case "Critical":
        return "critical-calendar";
      case "Normal Consultation":
        return "published-calendar";
      default:
        return "";
    }
  }


  return (
    <div className="main-calendar">
      <h1 className="headingh1">Today</h1>
      <div className="main-calendar-section">
        {Object.keys(boardData.tasks).length > 0 ? (
          Object.values(boardData.tasks).map((item, index) => {
            return (
              <Link to="/DashboardDashboardNavigation/history" onClick={() => handleSelectPatient(item)} className="calendar-cards" key={index}>
                <div className="img-h1">
                  <Avatar sx={{ width: { md: 40, lg: 50, xl: 50 }, height: { md: 40, lg: 50, xl: 50 }, bgcolor: item.img ? 'transparent' : stringToColor(item.content) }}
                    alt={item.content}
                    src={item.img} >
                    {!item.img && stringAvatar(`${item.content}`).children}
                  </Avatar>
                  <div className="card-text">{item.content}</div>
                </div>
                <div className="bottom-text">
                  <div className={`bottom-text-h ${getEventColor(item.tag)} ${getTextColor(item.tag)}`}>{item.tag}</div>
                  <div className="bottom-time">{item.time}</div>
                </div>
              </Link>
            )
          })
        ) : (
          <div className="no-data-calebdar-sidebar">Data not available</div>
        )}
      </div>
    </div>

  );
}

export default CalendarSidebar;

